/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarSellerInfo_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly canShowSellerName: boolean | null;
    readonly " $refType": "PdpRespSidebarSellerInfo_user";
};
export type PdpRespSidebarSellerInfo_user$data = PdpRespSidebarSellerInfo_user;
export type PdpRespSidebarSellerInfo_user$key = {
    readonly " $data"?: PdpRespSidebarSellerInfo_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfo_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfo_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '34b127cf56092b378bfe25ab635f1fdf';
export default node;
